// Deep-linking hacia una sección/tab específica del panel, usado por el
// changelog y los tooltips de novedades (ej. un link que debe abrir
// directamente "Dorsales o folios" dentro de Configuración del evento).
//
// El panel no tiene rutas por sección: son tabs con estado interno
// (useState/this.state), anidados varias capas (diálogo de pantalla
// completa > tab > tab). No hay forma de "escuchar" la URL para eso, así
// que el mecanismo es simple y de una sola lectura: un query param "abrir"
// con el mismo string que ya se usa como "key" de cada Tab en el código
// (ej. ?abrir=tab-dorsal), leído una vez al montar cada capa involucrada.

export function getAbrirAnchor() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("abrir") || null;
  } catch (e) {
    return null;
  }
}

export function buildAbrirUrl(pathname, anchor) {
  return `${pathname}?abrir=${encodeURIComponent(anchor)}`;
}
